<div>
  <div
    [ngClass]="{ 'modal--show': popupOpen, 'modal--hide': !popupOpen }"
    class="modal modal--barcode-scanner"
    >
    <div class="modal-background"></div>

    <div class="modal-container" id="modal-barcode-scanner">
      <div class="barcode-scanner--top-bar button-bar button-bar--right">
        @if (multipleDevices) {
          <button
            (click)="switchCamera()"
            class="button--text"
            type="button"
            >
            <svg
              class="icon-switch-camera"
              height="24"
              viewBox="0 0 512 512"
              width="24"
              >
              <use xlink:href="/images/icons/svg-sprite.svg#switch-camera"></use>
            </svg>
          </button>
        }

        <button (click)="close()" class="button--text" type="button">
          <svg class="icon-close" height="24" viewBox="0 0 15 15" width="24">
            <use xlink:href="/images/icons/svg-sprite.svg#cross"></use>
          </svg>
        </button>
      </div>

      <div class="barcode-scanner--scanner-wrapper">
        <div class="barcode-scanner--loading-scanner">
          <span class="theme-primary-text-color">Loading camera...</span>
        </div>

        <zxing-scanner
          #scanner
          (scanSuccess)="scanSuccessHandler($event)"
          [formats]="allowedFormats"
        ></zxing-scanner>

        <div class="barcode-scanner--scanbox"></div>
      </div>

      <div class="barcode-scanner--scanresults">
        @if (!scannedResult && !barcodeValid) {
          <div
            class="barcode-scanner--no-results"
            >
            <svg
              class="icon-scanner"
              height="120"
              viewBox="0 0 85 67.9"
              width="150"
              >
              <use
                xlink:href="/images/icons/svg-sprite.svg#barcode-scanner"
              ></use>
            </svg>
            <span
            i18n="
              Barcode scanner: no barcode
              scanned@@barcode.scanner.no.barcode.scanned"
              >
            Scan & get planty
          </span>
          </div>
        }

        @if (scannedResult && barcodeProductResponse && barcodeValid) {
          <div
            class="barcode-scanner--results"
            >
            <span
              i18n="Barcode scanner: product found@@barcode.scanner.product.found"
              >
            Product found with barcode {{ barcodeValue }}.
          </span>
            <button
              (click)="redirectToProductDetail()"
              class="button theme-btn-primary"
              i18n="Barcode scanner: go to product@@barcode.scanner.go.to.product"
              type="button"
              >
            Go to product
          </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
